/** @jsxImportSource preact */
import { h } from 'preact';
import { IMPACT_PALETTE, IMPACT_LABELS, type ImpactPillVariant } from '../data/impactScale';

/**
 * Reads the radar's concentric bands: one swatch + word per ring, innermost
 * first. Sits directly beneath a SeverityRadar / NatSecRadar so a reader can
 * see that a polygon reaching the amber band means "Substantial" without
 * numbers on the axis.
 */
export function RadarScaleKey({ variant }: { variant: ImpactPillVariant }) {
  return (
    <div
      aria-label="Radar scale, innermost ring outwards"
      style={{
        display: 'flex',
        // Sized (10px text, 9px swatches, 9px gaps) so all five steps sit on
        // ONE line in both modals at desktop widths — a key that wraps
        // mid-scale reads as two scales. Still `wrap`, not `nowrap`: on a
        // phone-width modal the row must fold rather than scroll the page
        // sideways.
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 9,
        marginTop: 2,
        fontSize: 10,
        color: 'var(--gc-text-muted, #6b7280)',
        lineHeight: 1.3,
      }}
    >
      <span style={{ letterSpacing: 0.2, whiteSpace: 'nowrap' }}>Rings, centre outwards:</span>
      {IMPACT_PALETTE.map((p) => (
        <span key={p.score} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>
          <span aria-hidden="true" style={{ width: 9, height: 9, borderRadius: 2, background: p.bg, display: 'inline-block', flex: '0 0 auto' }} />
          {IMPACT_LABELS[variant][p.score]}
        </span>
      ))}
    </div>
  );
}
